import { CurlGenerator } from 'curl-generator';
import './style.css';

const CurlSnippet = ({ url, method, headers, body }) => {
  const params = {
    url,
    method,
    headers,
    body,
  };

  const curl = CurlGenerator(params);

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(curl);
    } else {
      console.log('clipboard not supported');
    }
  };

  return (
    <div className="curl-snippet-wrapper">
      <div className="copy-clipboard">
        <button
          className="btn btn-warning btn-copy-to-clipboard"
          onClick={copyToClipboard}
        >
          <i className="mr-2 far fa-clone icon-copy" />
          Copiar código
        </button>
      </div>

      <code className="curl-wrapper">{curl}</code>
    </div>
  );
};

export default CurlSnippet;
